import useDebounce from 'components/hooks/useDebounce';
import { useState } from 'react';

export default function useDebouncedValue(initialValue, delay) {
  const [value, setValue] = useState(initialValue);
  const [debouncedValue] = useDebounce(value, delay);
  return [debouncedValue, setValue];
}
